import React from "react";
import Button from "./buttons/Button";
import LabelWithTooltip from "./label/LabelWithTooltip";

const QueryWithTwoOptions = props => (
  <React.Fragment>
    <LabelWithTooltip
      label={props.query}
      tooltipContent={props.tooltipContent}
    />
    <div className="row">
      <div className="col-6" id="option1Button">
        <Button
          label={props.option1Label}
          buttonType={props.buttonType}
          onClick={e => props.option1OnClickHandler(e)}
          selected={
            typeof props.optionTwoIsSelected === "boolean" &&
            !props.optionTwoIsSelected
          }
        />
      </div>
      <div className="col-6" id="option2Button">
        <Button
          label={props.option2Label}
          buttonType={props.buttonType}
          onClick={e => props.option2OnClickHandler(e)}
          selected={
            typeof props.optionTwoIsSelected === "boolean" &&
            props.optionTwoIsSelected
          }
        />
      </div>
    </div>
  </React.Fragment>
);

export default QueryWithTwoOptions;
